import React, { useState } from "react";
import { Link } from "react-router-dom";
import MeAge from "./MeAge";

const RegisterSteps = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const goNext = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const goBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  return (
    <div className="register-steps-container">
      <div className="logo-container">
        <Link to="/">
          <img
            src="/will-care-logo-150x150.png"
            alt="Company Logo"
            width="100"
          />
        </Link>
      </div>
      <div className="separator"></div>
      <div className="intro-text">
        <h1>Thanks for that.</h1>
        <p>Are you over 18?</p>
        <p>You have to be over 18 to have a WillCare account.</p>
      </div>
      {currentStep === 1 && <MeAge goNext={goNext} />}
    </div>
  );
};

export default RegisterSteps;
